export default "__VITE_ASSET__BfKa7ywH__"